import { render } from "./Icon.vue?vue&type=template&id=9a335462"
import script from "./Icon.js?vue&type=script&lang=js"
export * from "./Icon.js?vue&type=script&lang=js"

import "./Icon.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Program Files\\Ampps\\www\\adapter\\metahumen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__